import { ema, rsi, macd } from "react-stockcharts/lib/indicator";
import dummyData from "./stock_list.json";
import { getIntraDayData, getSignalData } from "./data";

const ema20 = ema()
  .id(0)
  .options({ windowSize: 20 })
  .merge((d, c) => {
    d.ema20 = c;
  })
  .accessor((d) => d.ema20);

const ema50 = ema()
  .id(2)
  .options({ windowSize: 50 })
  .merge((d, c) => {
    d.ema50 = c;
  })
  .accessor((d) => d.ema50);

const ema100 = ema()
  .id(3)
  .options({ windowSize: 100 })
  .merge((d, c) => {
    d.ema100 = c;
  })
  .accessor((d) => d.ema100);

const ema200 = ema()
  .id(4)
  .options({ windowSize: 200 })
  .merge((d, c) => {
    d.ema200 = c;
  })
  .accessor((d) => d.ema200);

const rsiCalculator = rsi()
  .options({ windowSize: 14 })
  .merge((d, c) => {
    d.rsi = c;
  })
  .accessor((d) => d.rsi);

const macdCalculator = macd()
  .options({
    fast: 12,
    slow: 26,
    signal: 9,
  })
  .merge((d, c) => {
    d.macd = c;
  })
  .accessor((d) => d.macd);

async function asyncForEach(array, callback) {
  for (let item of array) {
    await callback(item);
  }
}

export async function getTableData() {
  const dataPromise = new Promise(async (resolve, reject) => {
    let finalData = [];
    let promises = [];
    // await asyncForEach(dummyData, async (item) => {
    //     const data = await getIntraDayData(item["Ticker"]);
    //     if (data.length >= 0) {
    //         const calculatedData = ema200(
    //           ema100(ema50(ema20(rsiCalculator(macdCalculator(data)))))
    //         ).slice(-1);
    //         finalData.push({
    //           ticker: item['Ticker'],
    //           company: item['Company'],
    //           data: calculatedData
    //         })
    //       }
    //   });
    // console.log("here");
    dummyData.forEach((element) => {
      promises.push(getIntraDayData(element["Ticker"], 30));
    });

    await Promise.all(promises).then((values) => {
      values.forEach((value, index) => {
        if (value.length >= 0) {
          const calculatedData = ema200(
            ema100(ema50(ema20(rsiCalculator(macdCalculator(value)))))
          ).slice(-1);
          finalData.push({
            ticker: dummyData[index]["Ticker"],
            company: dummyData[index]["Company"],
            data: calculatedData,
          });
        }
      });
    });

    resolve(finalData);
  });
  return dataPromise;
}


export async function getSignals() {
  const dataPromise = new Promise(async (resolve, reject) => {
    let finalData = [];
    let promises = [];
    dummyData.forEach((element) => {
      promises.push(getSignalData(element["Ticker"]));
    });

    await Promise.all(promises).then((values) => {
      console.log(values);
      values.forEach((value, index) => {
        if (value != null && value != undefined && value.length >= 0) {
          finalData.push({
            ticker: dummyData[index]["Ticker"],
            company: dummyData[index]["Company"],
            data: value,
          });
        }
      });
    });

    resolve(finalData);
  });
  return dataPromise;
}